import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  SET_CHANNELTOKEN: function (state, payload) {
    state.channelToken = payload
  },
  SELECT_CHANNEL: function (state, payload) {
    state.channel = payload
  },
  CHECK_MANAGE_PAGE: function (state, payload) {
    state.checkManagePage = payload
  }
}
